var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebuggerNoPredictionsIcon = function SvgDebuggerNoPredictionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 23,
    r: 22.5,
    stroke: "#3D4355"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.212 8.367-4.827-1.752-1.752-4.827a1.209 1.209 0 0 0-2.266 0L5.615 6.615.788 8.367a1.209 1.209 0 0 0 0 2.266l4.827 1.752 1.752 4.827a1.208 1.208 0 0 0 2.266 0l1.752-4.827 4.827-1.752a1.208 1.208 0 0 0 0-2.266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    d: "m10.915 6.785.08.22.22.08 4.823 1.75.002.001a.708.708 0 0 1 0 1.328h-.002l-4.823 1.751-.22.08-.08.22-1.75 4.823-.001.001a.708.708 0 0 1-1.328 0v-.001l-1.751-4.823-.08-.22-.22-.08-4.823-1.75-.001-.001a.708.708 0 0 1 0-1.328l4.824-1.751.22-.08.08-.22 1.751-4.824a.709.709 0 0 1 1.328.001z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.537 19.334-2.84-1.031-1.03-2.84a.711.711 0 0 0-1.334 0l-1.03 2.84-2.84 1.03a.711.711 0 0 0 0 1.334l2.84 1.03 1.03 2.84a.711.711 0 0 0 1.334 0l1.03-2.84 2.84-1.03a.711.711 0 0 0 0-1.334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5899DA",
    d: "m21.537 19.334-2.84-1.031-1.03-2.84a.711.711 0 0 0-1.334 0l-1.03 2.84-2.84 1.03a.711.711 0 0 0 0 1.334l2.84 1.03 1.03 2.84a.711.711 0 0 0 1.334 0l1.03-2.84 2.84-1.03a.711.711 0 0 0 0-1.334",
    opacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeWidth: 0.7,
    d: "m18.368 18.422.056.154.154.056 2.837 1.03a.36.36 0 0 1 .17.132l.288-.2-.288.2a.36.36 0 0 1-.17.544l-2.837 1.03-.154.056-.056.154-1.03 2.837a.36.36 0 0 1-.544.17l-.2.288.2-.288a.36.36 0 0 1-.132-.17l-1.03-2.837-.056-.154-.154-.056-2.838-1.03a.36.36 0 0 1 0-.676l2.838-1.03.154-.056.056-.154 1.03-2.838a.36.36 0 0 1 .676 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M18.5 47.5h17M15.5 49.5h23"
  })));
};
export default SvgDebuggerNoPredictionsIcon;